import { SubscriptionPlan } from "@/types/subscription";

export const subscriptionPlans: SubscriptionPlan[] = [
  {
    id: "basic",
    name: "Basic",
    description: "Perfect for small businesses getting started with competitor analysis",
    monthlyPrice: 29,
    annualPrice: 295, // ~15% discount for annual
    features: [
      "Up to 3 competitors",
      "Basic social media analytics",
      "Monthly market reports",
      "Email support"
    ],
    modules: [
      "Social Media Monitoring",
      "Basic Market Analysis",
      "Monthly Insights"
    ]
  },
  {
    id: "professional",
    name: "Professional",
    description: "Ideal for growing businesses needing deeper insights",
    monthlyPrice: 79,
    annualPrice: 805, // ~15% discount for annual
    popular: true,
    features: [
      "Up to 10 competitors",
      "Advanced social media analytics",
      "Weekly market reports",
      "Priority email & chat support",
      "Custom alerts"
    ],
    modules: [
      "Advanced Social Media Analytics",
      "Competitor Tracking",
      "Market Sentiment Analysis",
      "Weekly Insights & Alerts"
    ]
  },
  {
    id: "enterprise",
    name: "Enterprise",
    description: "Full-featured solution for large organizations",
    monthlyPrice: 199,
    annualPrice: 2030, // ~15% discount for annual
    features: [
      "Unlimited competitors",
      "Real-time analytics",
      "Custom reports",
      "24/7 priority support",
      "API access",
      "Custom integrations"
    ],
    modules: [
      "Enterprise Analytics Suite",
      "Real-time Monitoring",
      "Custom Reporting",
      "API Access",
      "Dedicated Support"
    ]
  }
]; 